import enActivateCard from './activateCard.i18n.json';

export const activateCard = {
  en: enActivateCard,
};
